import React from 'react'
import { categoryMeta } from './model'

// A reason's label (the backend's) in its category's colours.
export default function ReasonPill({ reason }) {
  if (!reason) return null
  const meta = categoryMeta(reason.category)
  return (
    <span className="bk-pill" data-category={meta.id} title={meta.label} style={{ color: meta.fg, background: meta.bg }}>
      {reason.label}
    </span>
  )
}
